import React from "react";

const CategoryHero = (props) => {
  const { category } = props;
  const links = category.events.map((event, index) => (
    <span
      className="virtual-events-category-hero__link scroll-to"
      key={event.name + index}
      data-scroll-to={event.name.replace(/\s/g, "")}
    >
      {event.name}
    </span>
  ));
  return (
    <div className="virtual-events-category-hero container">
      <h1 className="virtual-events-category-hero__title">{category.name}</h1>
      <p className="virtual-events-category-hero__copy">{category.copy}</p>
      <img
        className="virtual-events-category-hero__images virtual-events-category-hero__images--one"
        src={category.categoryHeroImages[0]}
        alt="hero image"
      />
      <img
        className="virtual-events-category-hero__images virtual-events-category-hero__images--two"
        src={category.categoryHeroImages[1]}
        alt="hero image"
      />
      <div className="virtual-events-category-hero__links">{links}</div>
    </div>
  );
};

export default CategoryHero;
